import React, { useState } from "react";
import { Sun, Moon, Monitor } from "lucide-react";

const Appearance = () => {
  const [theme, setTheme] = useState("light");

  return (
    <div className="max-w-2xl">
      <h2 className="text-lg font-semibold text-gray-900 mb-6">Appearance</h2>

      <div className="space-y-4">
        <p className="text-sm text-gray-600 mb-6">
          Choose how the app looks to you. Select a single theme or sync with your system settings.
        </p>

        {/* Theme Options */}
        <div className="space-y-3">
          {/* System Theme */}
          <label className="flex items-center p-4 border-2 border-gray-200 rounded-2xl cursor-pointer hover:border-purple-300 transition-colors">
            <input
              type="radio"
              name="theme"
              value="system"
              checked={theme === "system"}
              onChange={(e) => setTheme(e.target.value)}
              className="h-4 w-4 text-purple-600 focus:ring-purple-500 border-gray-300"
            />
            <div className="ml-3 flex items-center flex-1">
              <Monitor className="w-5 h-5 text-gray-600 mr-3" />
              <div>
                <p className="text-sm font-medium text-gray-900">System</p>
                <p className="text-xs text-gray-500">Sync with your system theme</p>
              </div>
            </div>
          </label>

          {/* Light Theme */}
          <label className="flex items-center p-4 border-2 border-purple-500 rounded-2xl cursor-pointer bg-purple-50">
            <input
              type="radio"
              name="theme"
              value="light"
              checked={theme === "light"}
              onChange={(e) => setTheme(e.target.value)}
              className="h-4 w-4 text-purple-600 focus:ring-purple-500 border-gray-300"
            />
            <div className="ml-3 flex items-center flex-1">
              <Sun className="w-5 h-5 text-yellow-600 mr-3" />
              <div>
                <p className="text-sm font-medium text-gray-900">Light Mode</p>
                <p className="text-xs text-gray-500">Classic bright theme (Current)</p>
              </div>
            </div>
          </label>

          {/* Dark Theme */}
          <label className="flex items-center p-4 border-2 border-gray-200 rounded-2xl cursor-not-allowed opacity-60">
            <input
              type="radio"
              name="theme"
              value="dark"
              disabled
              className="h-4 w-4 text-purple-600 focus:ring-purple-500 border-gray-300"
            />
            <div className="ml-3 flex items-center flex-1">
              <Moon className="w-5 h-5 text-gray-600 mr-3" />
              <div>
                <p className="text-sm font-medium text-gray-900">Dark Mode</p>
                <p className="text-xs text-gray-500">Coming soon</p>
              </div>
            </div>
          </label>
        </div>

        {/* Info Note */}
        <div className="mt-6 p-4 bg-blue-50 border border-blue-200 rounded-2xl">
          <p className="text-sm text-blue-800">
            <strong>Note:</strong> Dark mode is currently under development and will be available in a future update. The app currently uses a light theme with purple/blue gradient accents.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Appearance;
